<template>
  <nav
      class="shadow-none navbar navbar-main navbar-expand-lg border-radius-xl"
      v-bind="$attrs"
      id="navbarBlur"
      data-scroll="true"
      :class="isAbsolute ? 'mt-4' : 'mt-0'"
      ref="navbar"
  >
    <div
        class="container-fluid d-flex align-items-center justify-content-between"
        ref="navbarContent"
    >

      <!-- Logo -->
      <div class="d-flex align-items-center logo-wrapper">
        <img src="@/assets/najih_logo.png" alt="Najih Logo" class="najih-logo" />
      </div>

      <!-- Breadcrumbs -->
      <div class="flex-grow-1 ms-3">
        <breadcrumbs :currentPage="currentRouteName" :color="color" />
      </div>

      <!-- Right-side user section -->
      <div class="d-flex align-items-center">
        <ul class="navbar-nav justify-content-end">
          <!-- User Dropdown -->
          <li class="nav-item dropdown pe-2 d-flex align-items-center">
            <a
                class="nav-link d-flex align-items-center"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                :class="color || 'text-body'"
            >
              <i class="material-icons" :class="isRTL ? 'ms-sm-2' : 'me-sm-1'">account_circle</i>
              <span class="dropdown-arrow"></span>
            </a>

            <ul class="dropdown-menu dropdown-menu-end">
              <li>
                <a
                    href="#"
                    @click.prevent="handleLogout"
                    class="dropdown-item d-flex align-items-center"
                >
                  <i class="material-icons me-2">logout</i>
                  Logout
                </a>
              </li>
            </ul>
          </li>

          <!-- Sidebar toggle -->
          <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
            <a
                href="#"
                @click.prevent="toggleSidebar"
                class="p-0 nav-link text-body"
                id="iconNavbarSidenav"
            >
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import Breadcrumbs from "../Breadcrumbs.vue";
import { mapMutations, mapState } from "vuex";

export default {
  name: "Navbar",
  components: {
    Breadcrumbs,
  },
  props: {
    minNav: Boolean,
    color: String,
  },
  computed: {
    ...mapState(["isRTL", "isAbsolute"]),
    currentRouteName() {
      return this.$route.name;
    },
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
    toggleSidebar() {
      this.navbarMinimize();
    },
    async handleLogout() {
      try {
        await this.$store.dispatch("auth/logout");
        this.$router.push({ name: "Login" });
      } catch (err) {
        console.error("Logout error:", err);
      }
    }
  }
};
</script>

<style scoped>
/* CRITICAL: Force navbar to be compact with maximum specificity */
nav.navbar.navbar-main.navbar-expand-lg {
  min-height: 60px !important;
  max-height: 60px !important;
  height: 60px !important;
  padding: 0 !important;
  margin-bottom: 0 !important;
  overflow: visible !important;
}

nav.navbar .container-fluid {
  min-height: 50px !important;
  max-height: 50px !important;
  height: 50px !important;
  padding: 0.5rem 1rem !important;
  margin: 0 !important;
}

/* Dropdown arrow style */
.dropdown-arrow {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.5em;
  vertical-align: middle;
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-left: 0.3em solid transparent;
}

/* Logo style */
.najih-logo {
  height: 30px !important;
  max-width: 80px !important;
  object-fit: contain;
}

.logo-wrapper {
  margin-right: 0.5rem;
  padding: 0;
}

/* Navigation items - compact with maximum specificity */
.navbar-nav {
  margin: 0 !important;
  padding: 0 !important;
}

.navbar-nav .nav-item {
  display: flex !important;
  align-items: center !important;
  margin: 0 !important;
  padding: 0 !important;
  height: auto !important;
}

.navbar-nav .nav-link {
  padding: 0.5rem 0.75rem !important;
  display: flex !important;
  align-items: center !important;
  line-height: 1.5 !important;
  height: auto !important;
}

/* Dropdown menu - proper positioning */
.dropdown-menu {
  position: absolute !important;
  z-index: 1050 !important;
  min-width: 10rem !important;
  margin-top: 0.5rem !important;
  top: 100% !important;
}

.dropdown-menu-end {
  right: 0 !important;
  left: auto !important;
}

/* Dropdown item styling */
.dropdown-item {
  padding: 0.5rem 1rem !important;
  display: flex !important;
  align-items: center !important;
  white-space: nowrap !important;
  cursor: pointer !important;
}

.dropdown-item:hover {
  background-color: #f8f9fa !important;
}

.dropdown-item i {
  font-size: 1.25rem !important;
}

/* Breadcrumb compact styling */
.navbar .breadcrumb {
  margin-bottom: 0 !important;
  padding: 0 !important;
  font-size: 0.875rem !important;
}

.navbar h6 {
  margin-bottom: 0 !important;
  font-size: 1rem !important;
}

/* Force all nested elements to have proper heights */
.navbar * {
  box-sizing: border-box !important;
}

.navbar .d-flex {
  align-items: center !important;
}
</style>